import { render, staticRenderFns } from "./union_card.vue?vue&type=template&id=b313b930"
import script from "./union_card.vue?vue&type=script&lang=js"
export * from "./union_card.vue?vue&type=script&lang=js"
import style0 from "./union_card.vue?vue&type=style&index=0&id=b313b930&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports